import { render, staticRenderFns } from "./Aprovadas.vue?vue&type=template&id=e46341ba&"
import script from "./Aprovadas.vue?vue&type=script&lang=js&"
export * from "./Aprovadas.vue?vue&type=script&lang=js&"
import style0 from "./Aprovadas.vue?vue&type=style&index=0&id=e46341ba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports